import { render } from "./Generic.vue?vue&type=template&id=659f196e&scoped=true"
import script from "./Generic.vue?vue&type=script&lang=js"
export * from "./Generic.vue?vue&type=script&lang=js"

import "./Generic.vue?vue&type=style&index=0&id=659f196e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659f196e"],['__file',"src/views/pharmarcy/Generic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "659f196e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('659f196e', __exports__)) {
    api.reload('659f196e', __exports__)
  }
  
  module.hot.accept("./Generic.vue?vue&type=template&id=659f196e&scoped=true", () => {
    api.rerender('659f196e', render)
  })

}


export default __exports__